import { Close, ShoppingCart } from "@mui/icons-material";
import { Fab } from "@mui/material";
import useStore from "../utils/useStore";


export default function CartButton(){

    const { showCart, toggleCart } = useStore()

    return (

        <div className="apply-fab" >

            <Fab 
                color="secondary" 
                onClick={() => toggleCart()}
                sx={sx}
            >

                {showCart ? 
                    <Close /> 
                    :
                    <ShoppingCart />
                }

            </Fab>

        </div>
    );
}

const sx = {
    position: 'fixed',
    left: 10,
    bottom: 10
}